var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChallengerSpirit = function SvgChallengerSpirit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M70.88 69.53 46 22.75V19h11a1 1 0 0 0 .92-.62 1 1 0 0 0-.21-1.09L54.41 14l3.3-3.29a1 1 0 0 0 .21-1.09A1 1 0 0 0 57 9H45a1 1 0 0 0-1 1v12.75L31 47.22l-4.1-7.69a1 1 0 0 0-1.76 0l-16 30A1 1 0 0 0 10 71h60a1 1 0 0 0 .88-1.47M45 25.13 52.38 39h-4.07a4.27 4.27 0 0 0-3.4 1.84C44.24 41.6 43.84 42 43 42s-1.23-.4-1.9-1.16A4.29 4.29 0 0 0 37.71 39h-.09Zm7.29-11.84a1 1 0 0 0 0 1.42l2.3 2.29H46v-6h8.59ZM42 69H11.67L26 42.12l3.85 7.23-5.73 10.78a1 1 0 1 0 1.76.94L36.56 41h1.15c.83 0 1.22.4 1.9 1.16a4.06 4.06 0 0 0 6.8 0c.67-.76 1.07-1.16 1.9-1.16h5.13l14.89 28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M52.61 44.58a1 1 0 0 0-1.76.94l10.76 20.23a1 1 0 1 0 1.76-.94Z"
  })));
};
export default SvgChallengerSpirit;